import styled, { css } from 'styled-components';
import type { TransactionProps } from '@/pages/CompanyReport/components/InsiderTradingTransactions/components/Transaction';
import { TransactionType } from '@/pages/CompanyReport/components/InsiderTradingTransactions/components/Transaction';
import ChevronRightSVG from '@assets/images/icons/legacy/chevron-right.svg';
import ChevronDownSVG from '@assets/images/icons/legacy/chevron-down.svg';

const chevron = css`
  width: ${({ theme }) => theme.x2spacePx - 4}px;
  height: ${({ theme }) => theme.x2spacePx - 4}px;
  position: absolute;
  bottom: ${({ theme }) => theme.x1spacePx + 5}px;
  right: 10px;
  > * {
    fill: white;
  }
  opacity: 0.3;
`;

export const Accordion = styled('section')`
  ${({ theme }) => theme.typography.xSmall}
  border: 1px solid rgba(255,255,255,0.2);
  &:not(:last-child) {
    border-bottom: none;
  }
  padding: ${({ theme }) => theme.x1spacePx}px 10px;
`;

export const Header = styled('header')`
  position: relative;
  cursor: pointer;
  padding: ${({ theme }) => theme.x1spacePx}px 10px;
  margin: -${({ theme }) => theme.x1spacePx}px -10px;
`;

export const Body = styled('table')`
  width: 100%;
  padding-top: ${({ theme }) => theme.x1spacePx}px;
  table-layout: auto;
  border-spacing: 0;
  td {
    vertical-align: top;
    padding: ${({ theme }) => theme.x1spacePx}px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    &:nth-child(1) {
      color: ${({ theme }) => theme.color.white};
      > span {
        opacity: 0.5;
      }
      width: ${({ theme }) => theme.x9spacePx}px;
    }
  }
`;

export const Date = styled('span')`
  position: absolute;
  top: ${({ theme }) => theme.x1spacePx}px;
  right: 10px;
`;

export const Owner = styled('div')`
  position: relative;
  ${({ theme }) => theme.typography.xSmallStrong}
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  padding-right: ${({ theme }) => theme.x2spacePx}px;
`;

export const OwnerName = styled('span')`
  margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
`;

export const TransactionTypePositioned = styled(
  TransactionType
)<TransactionProps>`
  position: absolute;
  top: ${({ theme }) => theme.x1spacePx}px;
  left: 10px;
`;

export const ChevronRight = styled(ChevronRightSVG)`
  ${chevron}
`;

export const ChevronDown = styled(ChevronDownSVG)`
  ${chevron}
`;
